import React from 'react';
import { motion } from 'framer-motion';
import { useLanguage } from '../data/i18n';
import { NEXT_LEVEL_MEDIA } from '../data/site';
import { VideoPlayer } from './VideoPlayer';
export function NextLevel() {
  const {
    t
  } = useLanguage();
  return <section className="relative w-full border-y border-white/10 bg-steel py-24 sm:py-32" data-id="element-176" data-mp="r6a2j8374do">
      <div className="mx-auto grid max-w-6xl gap-14 px-6 lg:grid-cols-2 lg:gap-20" data-id="element-177" data-mp="5rkjo5pc6mdt">
        <motion.div initial={{
        opacity: 0,
        x: -20
      }} whileInView={{
        opacity: 1,
        x: 0
      }} viewport={{
        once: true,
        margin: '-80px'
      }} transition={{
        duration: 0.7
      }} data-id="element-178" data-mp="34bkgmh7j743l">
          <p className="font-sans text-[10px] uppercase tracking-[0.4em] text-ash" data-id="element-179" data-mp="3iyvregvw2k2n">{t.nextLevel.eyebrow}</p>
          <h2 className="mt-5 font-display text-5xl sm:text-7xl leading-[0.9] tracking-[0.04em] text-bone" data-id="element-180" data-mp="2ljrkwf12v4s6">
            {t.nextLevel.title.split(' ').slice(0, -1).join(' ')}{' '}
            <span className="text-[#D4AF37]" data-id="element-181" data-mp="2qg8azeru7t7w">{t.nextLevel.title.split(' ').pop()}</span>
          </h2>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        x: 20
      }} whileInView={{
        opacity: 1,
        x: 0
      }} viewport={{
        once: true,
        margin: '-80px'
      }} transition={{
        duration: 0.7,
        delay: 0.1
      }} className="space-y-6" data-id="element-182" data-mp="16uw2anlahow">
          <p className="font-body text-base sm:text-lg font-light leading-relaxed text-white/70" data-id="element-183" data-mp="3jlcjot8danuv">{t.nextLevel.body}</p>

          <ul className="flex flex-wrap justify-center sm:justify-start gap-3 pt-2" data-id="element-184" data-mp="3elq5aggsz1kh">
            {t.nextLevel.pillars.map(p => <li key={p} className="border border-white/25 px-4 py-2 font-sans text-[10px] uppercase tracking-[0.25em] text-bone" data-id="element-185" data-mp="39o7sgezo0277">
                {p}
              </li>)}
          </ul>

          <p className="pt-4 font-body text-base font-light leading-relaxed text-white/70" data-id="element-186" data-mp="17w36rl8re14x">{t.nextLevel.lead}</p>
          <p className="font-display text-3xl sm:text-4xl tracking-[0.1em] text-bone" data-id="element-187" data-mp="13v9kewaysue5">{t.nextLevel.punch}</p>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-80px'
      }} transition={{
        duration: 0.7,
        delay: 0.2
      }} className="lg:col-span-2 mt-8 grid gap-4 sm:grid-cols-3" data-id="element-188" data-mp="2xbm9niv1w39z">
          {NEXT_LEVEL_MEDIA.map((media, i) => media.type === 'video' ? <VideoPlayer key={i} src={media.src} className="aspect-[4/5]" data-id="element-189" data-mp="3g1c5886n0t2y" /> : <div key={i} className="relative aspect-[4/5] w-full overflow-hidden ring-1 ring-white/15 bg-black" data-id="element-190" data-mp="3l0f6rinesh66">
                <img src={media.src} alt="" className="h-full w-full object-cover grayscale contrast-125 transition-all duration-500 hover:grayscale-0" data-id="element-191" data-mp="3c1tid6v9a7xh" />
              </div>)}
        </motion.div>
      </div>
    </section>;
}